import theme from '../../../themes/colors';

export const getGroupCardColor = (id: string) => {
  if (!id || typeof id !== 'string' || id.trim() === '')
    return theme.cofeeGreyBlue75;

  const bgColorList = [
    theme.cofeeBlue50,
    theme.cofeeOrange50,
    theme.cofeePurple50,
    theme.cofeeGreen1,
    theme.cofeeRed1,
    theme.cofeeYellow1,
    theme.cofeeViolet50
  ];

  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) % 2_147_483_647;
  }

  const index = Math.abs(hash) % bgColorList.length;
  return bgColorList[index];
};

export const getGroupCardTextColor = (bgColor: string) => {
  const colorMapping = {
    [theme.cofeeBlue75]: theme.cofeeBlue400,
    [theme.cofeeOrange50]: theme.cofeeOrange500,
    [theme.cofeePurple50]: theme.cofeePurple500,
    [theme.cofeeGreen1]: theme.cofeeGreen10,
    [theme.cofeeRed1]: theme.cofeeRed10,
    [theme.cofeeYellow1]: theme.cofeeYellow10,
    [theme.cofeeViolet50]: theme.cofeeViolet500,
    [theme.cofeeGreyBlue75]: theme.cofeeGreyBlue400
  };

  return colorMapping[bgColor] || theme.cofeeGreyBlue400;
};
